module.exports = __webpack_public_path__ + "static/img/wechat.a0fcf6b2.svg";